import React, { useEffect } from "react";
import { useHistory } from "react-router";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import { useModuleAccess } from "../../hooks/useModuleAccess";

/**
 * MES Root Component
 * Redirects to the first MES section the current role may open (Planning by
 * default).
 */
const MES = () => {
  const history = useHistory();
  const { mesLandingPath } = useModuleAccess();

  useEffect(() => {
    history.replace(mesLandingPath);
  }, [history, mesLandingPath]);

  return <LoadingSpinner />;
};

export default MES;
